module.exports = __webpack_public_path__ + "img/sleep-better.9cc9aee0.svg";